/**
 * Кому открыт экран — ЕДИНСТВЕННЫЙ источник для маршрутизатора и для всякого,
 * кто ведёт на экран ссылкой (Блок 2 · Ф7 · В11-a, фикс-пак 1).
 *
 * До фикс-пака панель уведомлений держала свою копию этих наборов рядом с
 * `routes.tsx`: совпадали они по случайности, и расхождение дало бы ссылку,
 * ведущую в «Доступ запрещён». Теперь `routes.tsx` и `notification-target.ts`
 * читают одно и то же значение.
 *
 * ⚠️ Здесь только три экрана — те, на которые ведёт панель. Остальные гейты
 * `routes.tsx` второго потребителя не имеют и остаются на месте.
 */
import type { AccessLevel } from '@aris/shared';

export const ROUTE_ACCESS = {
  /** `/my` — «Мои работы». */
  myWorks: ['EMPLOYEE', 'MANAGER'],
  /** `/tasks` — «Задачи». */
  tasks: ['EMPLOYEE', 'MANAGER', 'ADMIN'],
  /** `/projects`, `/projects/:id` и соседи по тому же гейту. */
  projects: ['MANAGER', 'ADMIN'],
} as const satisfies Record<string, readonly AccessLevel[]>;
